import { css, Theme } from '@emotion/react';
import { Box, Typography } from '@mui/material';

const containerCSS = (theme: Theme) => css`
  display: flex;
  align-items: center;
  position: relative;
  gap: 1rem;

  &::before {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-color: ${theme.palette.divider};
  }

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-color: ${theme.palette.divider};
  }
`;

export function DividerOr() {
  return (
    <Box css={containerCSS}>
      <Typography paragraph={false}>OR</Typography>
    </Box>
  );
}
